// XSS-güvenli HTML kaçışı — innerHTML'e giden her dinamik değer esc()'ten geçmeli
const _escDiv = document.createElement('div');
export function esc(str: any): string {
  if (str == null) return '';
  _escDiv.textContent = String(str);
  // innerHTML &,<,> kaçırır; öznitelik içinde de güvenli olsun diye tırnakları da kaçır
  return _escDiv.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Telefonda her sayfanın tepesinde iOS tarzı büyük başlık durur. Sayfalar
// içeriği setHTML ile bastığı için başlık burada, içerik yazıldıktan sonra
// eklenir; aksi hâlde sayfa render'ı başlığı siler.
let bigTitle: { title: string; sub: string } = { title: '', sub: '' };
export function setBigTitle(title: string, sub = '') { bigTitle = { title, sub }; }

export function setHTML(el: string | Element | null, html: string) {
  if (typeof el === 'string') el = document.querySelector(el);
  if (!el) return;
  el.innerHTML = html;  // SAFE: çağıranlar dinamik değerleri esc() ile kaçırır
  if ((el as Element).id === 'content' && bigTitle.title) {
    const block = document.createElement('div');
    block.className = 'large-title-block';
    const h = document.createElement('h1');
    h.className = 'large-title';
    h.textContent = bigTitle.title;
    block.appendChild(h);
    if (bigTitle.sub) {
      const p = document.createElement('p');
      p.className = 'large-title-sub';
      p.textContent = bigTitle.sub;
      block.appendChild(p);
    }
    el.insertBefore(block, el.firstChild);
  }
}

export const $ = (sel: string, ctx?: Element | Document): Element | null =>
  (ctx || document).querySelector(sel);

export const $$ = (sel: string, ctx?: Element | Document): NodeListOf<Element> =>
  (ctx || document).querySelectorAll(sel);

export function formatDate(d: string | null | undefined): string {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '—';
  return dt.toLocaleDateString('tr-TR', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatDateShort(d: string | null | undefined): string {
  if (!d) return '';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatCurrency(amount: number | null | undefined, currency?: string): string {
  if (amount == null || isNaN(Number(amount))) return '—';
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY', minimumFractionDigits: 2 }).format(Number(amount));
}

export function formatNumber(n: number | null | undefined, digits = 2): string {
  if (n == null || isNaN(Number(n))) return '—';
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(n));
}

// Durum anahtarı → Türkçe etiket. CSS sınıfı anahtar üzerinden kalır (status-paid vb.)
const STATUS_LABELS: Record<string, string> = {
  // genel
  active: 'Aktif', pending: 'Beklemede', cancelled: 'İptal', completed: 'Tamamlandı', in_progress: 'Devam Ediyor',
  review: 'İncelemede', on_hold: 'Askıda', draft: 'Taslak', sent: 'Gönderildi',
  // fatura
  unpaid: 'Ödenmedi', paid: 'Ödendi', overdue: 'Vadesi Geçti',
  // tahsilat
  confirmed: 'Onaylandı', confirming: 'Kontrol Ediliyor', rejected: 'Reddedildi', failed: 'Başarısız',
  // destek
  open: 'Açık', resolved: 'Çözüldü', closed: 'Kapalı',
  low: 'Düşük', normal: 'Normal', medium: 'Orta', high: 'Yüksek', urgent: 'Acil',
  general: 'Genel', billing: 'Fatura/Ödeme', technical: 'Teknik', other: 'Diğer',
  // hesap
  individual: 'Şahıs', business: 'Kurumsal', customer: 'Müşteri', admin: 'Yönetici',
  // doküman
  contract: 'Sözleşme', proposal: 'Teklif', deliverable: 'Teslimat', invoice: 'Fatura', receipt: 'Dekont',
  // fatura türü
  'e-arsiv': 'e-Arşiv', 'e-fatura': 'e-Fatura',
  // işlem günlüğü
  login: 'Giriş', login_failed: 'Başarısız giriş', created: 'Oluşturuldu', updated: 'Güncellendi', deleted: 'Silindi',
  approved: 'Onaylandı', deactivated: 'Pasife alındı', permanently_deleted: 'Kalıcı silindi', registered_pending: 'Kayıt (onay bekliyor)',
  password_changed: 'Şifre değişti', profile_updated: 'Profil güncellendi', delivery_confirmed: 'Teslimat onaylandı',
  transfer_notified: 'Havale bildirimi', status_changed: 'Durum değişti',
};

// CSS'te tanımlı durum sınıflarına eşleme (yeni anahtarlar mevcut renkleri kullanır)
const STATUS_CLASS: Record<string, string> = { unpaid: 'sent', rejected: 'failed', open: 'pending', resolved: 'completed', closed: 'cancelled', urgent: 'overdue', high: 'confirming', 'e-arsiv': 'active', 'e-fatura': 'active', business: 'active', individual: 'draft' };

export function statusLabel(status: string | null | undefined): string {
  if (!status) return '';
  return STATUS_LABELS[status] || status.replace(/_/g, ' ');
}

export function statusBadge(status: string | null | undefined): string {
  if (!status) return '';
  const cls = STATUS_CLASS[status] || status;
  // Nokta kaldırıldı: yumuşak pastel hapın içinde renkli nokta üretilmiş
  // arayüzlerin tipik rozeti. Durum artık tipografiyle anlatılıyor.
  return `<span class="status status-${esc(cls)}">${esc(statusLabel(status))}</span>`;
}

export function timeAgo(date: string | null | undefined): string {
  if (!date) return '';
  const diff = Date.now() - new Date(date).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'az önce';
  if (mins < 60) return mins + ' dk önce';
  const hours = Math.floor(mins / 60);
  if (hours < 24) return hours + ' sa önce';
  const days = Math.floor(hours / 24);
  if (days < 30) return days + ' gün önce';
  return formatDate(date);
}

export function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Günaydın';
  if (h < 18) return 'İyi günler';
  return 'İyi akşamlar';
}

export function icons() {
  if ((window as any).lucide) (window as any).lucide.createIcons({ nameAttr: 'data-lucide', attrs: {} });
}

export function today(): string {
  return new Date().toISOString().split('T')[0];
}

export const CURRENCIES = ['TRY', 'USD', 'EUR'];
export const KDV_RATES = [0, 1, 10, 20];

export function currencyOpts(selected?: string): string {
  return CURRENCIES.map(c => `<option value="${c}"${(selected || 'TRY') === c ? ' selected' : ''}>${c === 'TRY' ? '₺ TRY' : c === 'USD' ? '$ USD' : '€ EUR'}</option>`).join('');
}

export function kdvOpts(selected?: number): string {
  const sel = selected == null ? 20 : Number(selected);
  return KDV_RATES.map(r => `<option value="${r}"${sel === r ? ' selected' : ''}>%${r}</option>`).join('');
}

// TC kimlik no: 11 hane, ilk hane 0 olamaz; 10. hane = ((tek haneler)×7 − çift haneler) mod 10; 11. hane = ilk 10 toplamı mod 10
export function isValidTCKN(v: string): boolean {
  if (!/^[1-9]\d{10}$/.test(v)) return false;
  const d = v.split('').map(Number);
  const odd = d[0] + d[2] + d[4] + d[6] + d[8];
  const even = d[1] + d[3] + d[5] + d[7];
  if (((odd * 7 - even) % 10 + 10) % 10 !== d[9]) return false;
  return (d.slice(0, 10).reduce((a, b) => a + b, 0) % 10) === d[10];
}
// Vergi kimlik no: 10 hane, GİB kontrol basamağı algoritması
export function isValidVKN(v: string): boolean {
  if (!/^\d{10}$/.test(v)) return false;
  const d = v.split('').map(Number);
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const t = (d[i] + (9 - i)) % 10;
    const q = (t * Math.pow(2, 9 - i)) % 9;
    sum += (t !== 0 && q === 0) ? 9 : q;
  }
  return ((10 - (sum % 10)) % 10) === d[9];
}

// Müşteri için "Ayarlar" fazla teknik duruyor; orada kendi bilgilerini
// düzenliyor. Admin'de gerçekten şirket/banka ayarları var, adı kalıyor.
export function settingsLabel(admin: boolean): string {
  return admin ? 'Ayarlar' : 'Bilgilerim';
}
